import {
  combineReducers
} from "redux";
import {
  dataReducer
} from "./dataReducer/data.reducer";
export const rootReducer = combineReducers({
  data: dataReducer,
});